import PropTypes from "prop-types";

export default PropTypes.shape({
  socialUrl: PropTypes.string,
  status: PropTypes.string.isRequired,
  channel: PropTypes.arrayOf(PropTypes.string.isRequired),
  multiply_parent: PropTypes.string,
});
